/**
 * The two string helpers every screen in the console needs.
 *
 * They lived inside the CSV importer's file until that panel moved to the admin
 * screen, which is exactly the failure mode of parking shared code in a file
 * named after a component: six screens ended up importing from a panel none of
 * them rendered. A module named after what it holds cannot go stale that way.
 */

export const plural = (count: number, noun: string): string =>
  `${count} ${noun}${count === 1 ? '' : 's'}`;

/**
 * Whatever a rejected promise carried, rendered as something a person can read.
 * `ApiError` already carries the server's own wording, so an `Error` message is
 * the useful string in both the expected and the unexpected case.
 */
export const message = (cause: unknown): string =>
  cause instanceof Error ? cause.message : String(cause);
